export default "__VITE_ASSET__BbXv_Phh__"